import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationMT from './locales/mt.json';

const resources = {
  en: {
    translation: translationEN,
  },
  mt: {
    translation: translationMT,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
